import { render, staticRenderFns } from "./chater.vue?vue&type=template&id=9d732efe&scoped=true"
import script from "./chater.vue?vue&type=script&lang=js"
export * from "./chater.vue?vue&type=script&lang=js"
import style0 from "./chater.vue?vue&type=style&index=0&id=9d732efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d732efe",
  null
  
)

export default component.exports